import { Box, Container, Divider, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export function LegalFooter() {
  return (
    <Box component="footer" sx={{ mt: 6, py: 3, bgcolor: 'background.paper' }}>
      <Container maxWidth="lg">
        <Divider sx={{ mb: 2 }} />
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          spacing={2}
          alignItems={{ sm: 'center' }}
        >
          <Typography variant="caption" color="text.secondary">
            © {new Date().getFullYear()} Premium Energy — Outil interne
          </Typography>
          <Stack direction="row" spacing={2}>
            <Link component={RouterLink} to="/legal/mentions" underline="hover" variant="caption">
              Mentions légales
            </Link>
            <Link component={RouterLink} to="/legal/privacy" underline="hover" variant="caption">
              Confidentialité
            </Link>
            <Link component={RouterLink} to="/legal/accessibility" underline="hover" variant="caption">
              Accessibilité
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
